export const AuthPAGES = {
  changePhone: "/change-phone",
  verifyPhone: "/verify-phone",
  signIn: "/SignIn",
};
